export default __webpack_public_path__ + "images/QX.4727457.png";